<article class="webinar-widget">
  <ng-template [ngIf]="isBrowser" [ngIfElse]="noBrowser">
    <div class="ground" [lazyLoad]="assetsUrl('/assets/images/webinar_banner_ground.jpg')"></div>
  </ng-template>
  <ng-template #noBrowser>
    <div class="ground no-browser"></div>
  </ng-template>
  <div class="text-block">
    <h2 class="title bold">{{ 'webinar-widget.title' | customLocale }}</h2>
    <p class="text normal" [innerHTML]="'webinar-widget.text' | customLocale"></p>
    <a routerLink="/overview-webinar" class="link">
      <button class="action normal">{{ 'webinar-widget.action' | customLocale }}</button>
    </a>
  </div>
</article>
